import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const locationSlice = createSlice({
  name: "location",
  initialState: {
    loading: false,
    list: [],
    locationData: []
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getLocations:(state,action) => {
state.locationData=action.payload;
    }
  }
});

export const {  loading, getLocations } = locationSlice.actions;

export const getLocation = () =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_destination`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(getLocations(data?.destinations));
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      errorHandling(error);
    }
  };

  
  export const storeDestination = (formData,setForm) =>
    async (dispatch) => {
      try {
        dispatch(loading(true));
        const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_destination`;
        const { data } = await axios.post(url,formData, {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        });
        dispatch(loading(false));
        setForm({})
      } catch (error) {
        dispatch(loading(false));
        errorHandling(error);
      }
    };

    export const destroyDestination = (id) =>
      async (dispatch) => {
        try {
          const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_destination/${id}`;
          const { data } = await axios.post(url,{},{
            headers: {
              Authorization: localStorage.getItem('token')
            }
          });
        } catch (error) {
          errorHandling(error);
        }
      };
  
      export const updateLocation = (id,formData,setForm) =>
        async (dispatch) => {
          try {
            const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_destination/${id}`;
            const { data } = await axios.post(url,formData,{
              headers: {
                Authorization: localStorage.getItem('token')
              }
            });
            setForm({})
          } catch (error) {
            errorHandling(error);
          }
        };

export default locationSlice.reducer;